import { render } from "./PageFooter.vue?vue&type=template&id=a60c2988&scoped=true"
const script = {}

import "./PageFooter.vue?vue&type=style&index=0&id=a60c2988&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a60c2988"]])

export default __exports__